
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 200 200","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","fill":"currentColor","clip-rule":"evenodd","d":"M110.783 94.74a5.348 5.348 0 100-10.695 5.348 5.348 0 000 10.695z"}}),_c('path',{attrs:{"fill-rule":"evenodd","fill":"currentColor","clip-rule":"evenodd","d":"M73.346 81.37a8.022 8.022 0 018.022-8.022h37.437a8.023 8.023 0 018.023 8.022v37.437a8.023 8.023 0 01-8.023 8.022H81.368a8.022 8.022 0 01-8.022-8.022V81.37zm8.022-2.674h37.437a2.674 2.674 0 012.674 2.674v37.437a2.66 2.66 0 01-.547 1.621 4.136 4.136 0 00-.266-.32L96.26 93.483c-3.281-3.58-8.967-3.446-12.076.285l-5.49 6.588V81.37a2.674 2.674 0 012.674-2.674zm-2.674 30.014v10.097a2.674 2.674 0 002.674 2.674h33.302L92.318 97.097a2.674 2.674 0 00-4.025.095l-9.599 11.518z"}})])
          )
        }
      }
    